module.exports = __webpack_public_path__ + "img/portal_blue_3.5513e9f7.png";